import { render, staticRenderFns } from "./HostProvider.vue?vue&type=template&id=4491d2de&scoped=true&"
import script from "./HostProvider.vue?vue&type=script&lang=js&"
export * from "./HostProvider.vue?vue&type=script&lang=js&"
import style0 from "./HostProvider.vue?vue&type=style&index=0&id=4491d2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4491d2de",
  null
  
)

export default component.exports